import { RetailerFooter } from "@faire/retailer-visitor-shared/components/Footer/RetailerFooter";
import {
  BlockInheritRow,
  ErrorRow,
} from "@faire/retailer-visitor-shared/components/SearchProducts/SearchProductsStyles";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";

export const SearchProductsError = () => {
  return (
    <div style={{ width: "100%" }}>
      <ErrorRow justify="center">
        <Typography>
          <StrictLocalMsg
            defaultMessage="An error has occurred, please try again."
            description={{
              text: "error message on search/discover and explore page when network failed",
            }}
          />
        </Typography>
      </ErrorRow>

      <BlockInheritRow>
        <RetailerFooter />
      </BlockInheritRow>
    </div>
  );
};
